<template>
	<div style="width: 100%;height: 100%;border-bottom: 1px solid var(--el-border-color-light);padding: 0 20px;gap: 10px;"
		class="row y_center">
		<div class="logo row y_center" style="font-weight: 600;color: var(--el-color-primary);">
			<el-icon size="34">
				<Sunny />
			</el-icon>
			<div class="row y_center" style="gap: 8px;">
				<span style="font-size: 18px;">SunAdmin</span>
				<span style="font-size: 12px;" id="sunadmin_version"></span>
			</div>
		</div>
		<div class="header-right row y_center">
			<el-button-group size="">
				<!-- 全屏按钮 -->
				<el-button :icon="isFullscreen ? 'Aim' : 'FullScreen'" @click="toggleFullScreen"></el-button>
				<!-- 主题切换 -->
				<el-button :icon="isDark ? 'Sunny' : 'Moon'" @click="toggleTheme"></el-button>
				<!-- 退出按钮 -->
				<el-button type="primary" :icon="SwitchButton" @click="handleLogout">退出
				</el-button>
			</el-button-group>


		</div>
	</div>
</template>

<script>
import { ref } from 'vue'
import { useLayoutStore } from "../../../../stores/layout"
import { useAccountStore } from "../../../../stores/account"
import { useSystemStore } from "../../../../stores/system"
import { ElMessageBox } from 'element-plus'
import { FullScreen, Aim, Moon, Sunny, SwitchButton } from '@element-plus/icons-vue'

export default {
	components: {
		FullScreen,
		Aim,
		Moon,
		Sunny,
		SwitchButton
	},
	setup() {
		const isFullscreen = ref(false)
		const isDark = ref(document.body.classList.contains('dark-theme'))
		const systemStore = useSystemStore()
		// 切换全屏
		const toggleFullScreen = () => {
			if (!document.fullscreenElement) {
				document.documentElement.requestFullscreen()
				isFullscreen.value = true
			} else {
				document.exitFullscreen()
				isFullscreen.value = false
			}
		}

		// 切换主题
		const toggleTheme = () => {
			isDark.value = !isDark.value
			if (isDark.value) {
				document.body.classList.add('dark-theme')
			} else {
				document.body.classList.remove('dark-theme')
			}
		}

		// 退出登录
		const handleLogout = () => {
			ElMessageBox.confirm('确认退出系统吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				useAccountStore().loginOut()
			}).catch(() => { })
		}

		return {
			isFullscreen,
			isDark,
			toggleFullScreen,
			toggleTheme,
			handleLogout,
			FullScreen,
			Aim,
			Moon,
			Sunny,
			SwitchButton,
			systemStore
		}
	}
}
</script>

<style scoped lang="less">
.header-right {
	margin-left: auto;

	:deep(.el-button) {
		font-size: 12px;

		.el-icon {
			font-size: 14px;
		}
	}

}
</style>